var map = {
	"./bigcartel-icon_dark.svg": 1641,
	"./bigcommerce-icon_dark.svg": 30389,
	"./etsy-icon_dark.svg": 56311,
	"./shopify-icon_dark.svg": 70500,
	"./squarespace-icon_dark.svg": 34203,
	"./woocommerce-icon_dark.svg": 38438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52340;